import { LANGUAGE } from '../actions';
import { LANG_EN_CONFIG, LANG_TH_CONFIG } from '../../constants';

const initialState = {
    currentLanguage: 'TH',
    wording: LANG_TH_CONFIG,
    basenameURL: ''
};

export default (state = initialState, { type, payload, error }) => {
    switch (type) {
        case LANGUAGE.UPDATE:
        case LANGUAGE.CHANGE:
            return {
                ...state,
                currentLanguage: payload,
                wording: payload === 'TH' ? LANG_TH_CONFIG : LANG_EN_CONFIG,
                basenameURL: payload === 'TH' ? '' : '/en'
            };

        default:
            return state;
    }
};
